import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/business/leads/$leadId/")({
    beforeLoad: ({ params, search }) => {
        throw redirect({ to: "/sales/leads/$leadId", params, search, replace: true });
    },
});
